import React, { useRef } from 'react';
import { gsap, useGSAP, MOTION_OK } from '../lib/gsap';

// Faixa de prova logo abaixo do hero. Só números e fatos confirmados.
const ProofBand = () => {
  const scope = useRef(null);
  const yearsRef = useRef(null);

  // Contagem dos anos chama o olho para a prova mais forte.
  useGSAP(
    () => {
      gsap.matchMedia().add(MOTION_OK, () => {
        const counter = { value: 0 };
        gsap.to(counter, {
          value: 15,
          duration: 1.6,
          ease: 'power2.out',
          scrollTrigger: { trigger: scope.current, start: 'top bottom', once: true },
          onUpdate: () => {
            if (yearsRef.current) yearsRef.current.textContent = Math.round(counter.value);
          },
        });
      });
    },
    { scope }
  );

  return (
    <section ref={scope} aria-label="Números da Atitude Som e Luz" className="border-y border-line px-4 md:px-8">
      <dl className="mx-auto grid max-w-7xl grid-cols-1 divide-y divide-line sm:grid-cols-3 sm:divide-x sm:divide-y-0">
        <div className="py-7 sm:pr-8">
          <dt className="text-sm text-soft">Anos de pista</dt>
          <dd className="mt-1 font-display text-4xl font-bold tracking-tight">
            <span ref={yearsRef}>15</span>+
          </dd>
        </div>
        <div className="py-7 sm:px-8">
          <dt className="text-sm text-soft">Especialidade</dt>
          <dd className="mt-1 font-display text-4xl font-bold tracking-tight">Flashback</dd>
        </div>
        <div className="py-7 sm:pl-8">
          <dt className="text-sm text-soft">Em um só contrato</dt>
          <dd className="mt-1 font-display text-4xl font-bold tracking-tight">DJ, som e luz</dd>
        </div>
      </dl>
    </section>
  );
};

export default ProofBand;
